import * as MobX from "mobx";

import { IsNotEmpty } from "class-validator";

import { ModelBase } from "@shoothill/core";

export class ResetPasswordModel extends ModelBase<ResetPasswordModel, ResetPasswordModelDTO> {
    @MobX.observable
    @IsNotEmpty({ message: "New password is required" })
    public newPassword: string = "";

    @MobX.observable
    @IsNotEmpty({ message: "Confirm password is required" })
    public confirmPassword: string = "";

    @MobX.observable
    public token: string = "";

    @MobX.action
    fromDto(model: ResetPasswordModelDTO): void {
        this.newPassword = model.newPassword;
        this.token = model.token;
    }

    toDto(model: ResetPasswordModel): void {}
}

export interface ResetPasswordModelDTO {
    newPassword: string;
    token: string;
}
